import { useEffect, useRef } from 'react';
import { Routes, Route, useLocation, useMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import RequireAuth from 'components/RequireAuth';

import Main from './components/SitePages/Main';
import Freight from './pages/Freight';
import Transport from './components/SitePages/Transport';
import Profile from './components/SitePages/Profile';
import NewPassword from './components/PopupForms/PasswordReset/NewPassword';
import RegistrationEmployee from 'components/PopupForms/RegistrationEmployee';
import Forums from './components/SitePages/Forums';
import LoginContainer from 'components/LoginContainer';
// import Tenders from './components/SitePages/Tenders';
// import Auction from './components/SitePages/Auction';
// import CheckingTheCompany from './components/SitePages/CheckingTheCompany';
// import Market from './components/SitePages/Market';
// import AirTransportations from './components/SitePages/AirTransportations';
// import Railage from "./components/SitePages/Railage";
// import Shipping from "./components/SitePages/Shipping";
// import Brokers from './components/SitePages/Brokers';
import CompanyPage from 'components/SitePages/CompanyPage';
import NoMatchPage from 'components/NoMatchPage';
import News from './components/SitePages/News';
import Partners from './components/SitePages/Partners';
import Useful from './components/SitePages/Useful';
import Tutorials from './components/SitePages/Tutorials';
import { AUTH } from './helpers/routes';
import Privacy from 'components/PopupForms/Privacy';
import Terms from 'components/PopupForms/Terms';

import "./components/page.scss";
import Contacts from 'components/SitePages/Contacts';

const MODAL_ROUTES = [AUTH.login, AUTH.registration, AUTH.forgot, '/privacy', '/terms'];

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!MODAL_ROUTES.includes(pathname)) {
      const appElement = document.querySelector('.App');
      if (appElement) {
        appElement.scrollTo(0, 0);
      }
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};
const DEFAULT_LOCATION = {
  hash: '',
  pathname: '/',
  search: '',
  state: undefined,
};

const Router = () => {
  const authenticated = useSelector((state) => state.auth.authenticated);
  const location = useLocation();
  const previousLocation = useRef(DEFAULT_LOCATION);

  const isMatchRestoreUrl = useMatch(AUTH.restore) !== null;

  useEffect(() => {
    if (!MODAL_ROUTES.includes(location.pathname) || isMatchRestoreUrl) {
      previousLocation.current = location;
    }
  }, [location, isMatchRestoreUrl]);

  const isModal =
    (MODAL_ROUTES.includes(location.pathname) || isMatchRestoreUrl) && previousLocation.current !== location;

  return (
    <>
      <ScrollToTop />
      <Routes location={isModal ? previousLocation.current : location}>
        <Route path="/" element={<Main />} />
        {!authenticated && <Route path="/registration/employee/" element={<RegistrationEmployee />} />}
        <Route path="/freight/*" element={<Freight />} />
        <Route path="/transport/*" element={<Transport />} />
        <Route path="/forums/*" element={<Forums />} />
        {/* <Route path='/tenders' element={<Tenders />} /> */}
        {/* <Route path='/auction' element={<Auction />} /> */}
        {/* <Route path='/market' element={<Market />} /> */}
        {/* <Route path='/brokers' element={<Brokers />} /> */}
        {/* <Route path='/air' element={<AirTransportations />} /> */}
        {/* <Route path='/railage' element={<Railage />} />
                <Route path='/shipping' element={<Shipping />} /> */}
                {/* <Route path='/company-check' element={<CheckingTheCompany />} /> */}
                <Route path="/news/*" element={<News />} />
                <Route path="/partners" element={<Partners />} />
                <Route path="/useful/*" element={<Useful />} />
                <Route path="/tutorials" element={<Tutorials />} />
                <Route
                    path="/profile/*"
                    element={<RequireAuth><Profile /></RequireAuth>}
                />
                <Route path="/company/:id" element={<CompanyPage />} />
                <Route path="/contacts/*" element={<Contacts />}/>
                <Route path="*" element={<NoMatchPage />} />
            </Routes>
              {isModal && (
                <Routes>
                  <Route path="/auth/*" element={<LoginContainer previousLocation={previousLocation.current} />} />
                </Routes>
              )}
              {isModal && !authenticated && (
                <Routes>
                  <Route path={AUTH.restore} element={<NewPassword />} />
                </Routes>
              )}
              {isModal && (
                <Routes>
                  <Route path="/privacy" element={<Privacy previousLocation={previousLocation.current} />} />
                </Routes>
              )}
              {isModal && (
                <Routes>
                  <Route path="/terms" element={<Terms previousLocation={previousLocation.current} />} />
                </Routes>
              )}
        </>
    );
};
export default Router;
